export const COMMON_ENV = {
    STORYBOOK_LOQATE_API_KEY: process.env.STORYBOOK_LOQATE_API_KEY,
    STORYBOOK_GET_ADDRESS_IO_API_KEY: process.env.STORYBOOK_GET_ADDRESS_IO_API_KEY,
    REACT_APP_LOQATE_API_KEY: process.env.REACT_APP_LOQATE_API_KEY,
    REACT_APP_GET_ADDRESS_IO_API_KEY: process.env.REACT_APP_GET_ADDRESS_IO_API_KEY,
};
